import * as urlUtil from '@tencent/vft-common/url';
import Version from '@tencent/vft-atom/lib/Version';
import atom from '@tencent/vft-atom';

/**
 * 在 h5 或 小程序 或 native 中打开
 * @return {String} h5/ weapp/ native
 */
const openType = function () {
  const env = window.magicApp?.env;
  const version = env?.appVersion;

  if (!version) return 'h5';

  const vObj = new Version(version);

  if ((env.isIos && !vObj.compare('10.13.5'))
    || (env.isAndroid && !vObj.compare('10.13.5.4'))) {
    return 'h5';
  }

  return 'weapp';
};

const qqmusicHandler = async function ({ cid, vid }) {
  if (!cid && !vid) return false;

  if (!window.magicApp?.env.isQQMusic) return false;

  const type = openType();

  if (type === 'h5') return false;

  if (type === 'weapp') {
    const path = urlUtil.buildUrl('preload_play/play/index.html', { cid, vid });
    atom.openUrl(`qqmusic://qq.com/ui/openWXMiniProgram?p=${encodeURIComponent(`{"appId":"wxa75efa648b60994b","enterPath":"${path}"}`)}`);
    return true;
  }

  return false;
};

export default qqmusicHandler;
